module.exports = "https://static.wmbcdn.com/uniweb/images/17f21643db6e4bda6c88fb10e0828934.svg";